import React from 'react';

export default function LoadingIndicatorThreeDots(props) {
    return (
        <span className="spinner">
            <span className="bounce1"></span>
            <span className="bounce2"></span>
            <span className="bounce3"></span>
        </span>
    );
}